import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

/**
 * KPI tile — a big number with a short label and an optional sub-line.
 * Clickable rows route to the relevant module with filters pre-applied.
 * `tone="danger"` highlights the number in red when the count is actionable.
 */
export function KpiCard({
    label,
    value,
    sub,
    tone = 'neutral',
    to,
}: {
    label: string;
    value: ReactNode;
    sub?: ReactNode;
    tone?: 'neutral' | 'danger';
    to?: string;
}) {
    const body = (
        <div className="flex flex-col gap-1">
            <span className="text-xs font-bold uppercase tracking-wide text-text-subtle">
                {label}
            </span>
            <span
                className={cn(
                    'text-3xl font-bold leading-none',
                    tone === 'danger' ? 'text-error-text' : 'text-text',
                )}
            >
                {value}
            </span>
            {sub && <span className="text-xs text-text-muted mt-1">{sub}</span>}
        </div>
    );

    const shell = 'bg-surface border border-border rounded-lg p-4 shadow-sm';

    if (to) {
        return (
            <Link
                to={to}
                className={cn(
                    shell,
                    'block hover:border-accent transition-colors duration-[var(--duration-base)]',
                )}
            >
                {body}
            </Link>
        );
    }
    return <div className={shell}>{body}</div>;
}
